import axios from "axios";
const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_VITE_BASE_URL,
  timeout: 50000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
const cancelSource = axios.CancelToken.source();
instance.interceptors.request.use((config: any) => {
  config.cancelToken = cancelSource.token;
  return {
    ...config,
    headers: {
      Accept: "application/json",
    },
  };
});

instance.interceptors.response.use(
  function (response: any) {
    // Optional: Do something with response data
    return response;
  },
  function (error: any) {
    // if (error.response && error.response.status === 403) {
    //   cancelSource.cancel("All requests canceled due to 403 status.");
    //   cancelSource = axios.CancelToken.source();
    //   return Promise.reject(error);
    //   //  window.location.href = '/license-key-expired'
    // }

    return Promise.reject(error);
  }
);
const CancelToken = axios.CancelToken;
const getTimeOut = () => {
  const source = CancelToken.source();

  setTimeout(() => {
    source.cancel();
  }, 60000);

  return source.token;
};

const requests = {
  get: (url?: any, headers?: any) =>
    instance.get(url, {
      ...headers,
      cancelToken: getTimeOut(),
    }),

  post: (url?: any, body?: any, headers?: any) =>
    instance.post(url, body, {
      ...headers,
      cancelToken: getTimeOut(),
    }),
  put: (url?: any, body?: any, headers?: any) =>
    instance.put(url, body, {
      ...headers,
      cancelToken: getTimeOut(),
    }),

  patch: (url?: any, body?: string, headers?: object) =>
    instance.patch(url, body, headers),

  delete: (url: string, headers?: any) =>
    instance.delete(url, {
      ...headers,
      cancelToken: getTimeOut(),
    }),
};

export default requests;
